import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useLocation } from "react-router-dom"; // ✅ to detect active route
import "./navbar.css";

const NavigationBar = () => {
  const location = useLocation(); // ✅ Get current route

  // Function to check active path
  const isActive = (path) => location.pathname === path;

  return (
    <Navbar expand="lg" className="custom-navbar fixed-top">
      <Container>
        {/* Logo Section */}
        <Navbar.Brand href="/" className="navbar-logo">
          <img
            src="/Lismount.png"
            alt="linen Fabrics Logo"
            className="logo-img"
          />
        </Navbar.Brand>

        {/* Mobile Toggle */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {/* Navigation Links */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center nav-links">
            <Nav.Link
              href="/"
              className={`nav-link ${isActive("/") ? "active-nav" : ""}`}
            >
              Home
            </Nav.Link>
            <Nav.Link
              href="/about"
              className={`nav-link ${isActive("/about") ? "active-nav" : ""}`}
            >
              About
            </Nav.Link>
            <Nav.Link
              href="/product"
              className={`nav-link ${
                isActive("/product") ? "active-nav" : ""
              }`}
            >
              Product
            </Nav.Link>
            <Nav.Link
              href="/business"
              className={`nav-link ${isActive("/business") ? "active-nav" : ""}`}
            >
              Our Business
            </Nav.Link>
            <Nav.Link
              href="/contact"
              className={`nav-link ${isActive("/contact") ? "active-nav" : ""}`}
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
